export default {
  props: {
    category: {
      type: Object,
      default: () => {},
    },
    flashcard: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: -1,
    },
    isLearningPath: {
      type: Boolean,
      default: false,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    currentPosition() {
      // this is for the lesson show page
      if (this.index !== -1 && this.totalCount !== 0) {
        return {
          position: this.index + 1,
          total: this.totalCount,
        };
      }
      // Guard against undefined or incomplete flashcard data
      if (!this.flashcard || !this.flashcard.id) {
        return {
          position: 0,
          total: 0,
        };
      }
      let position = 0;
      let total = 0;
      if (this.isLearningPath) {
        const learningPath = this.$store.getters['learningPath/flashcards'];
        total = learningPath.length;
        position = learningPath.findIndex(item => item.flashcardId === this.flashcard.id) + 1;
      } else if (this.category && this.$store.getters['categoryTypes/quizCategoryTypes'].map(ct => ct.id).includes(this.category.categoryTypeId)) {
        total = this.category.counts.total;
        position = (total - this.currentSession.length) + this.currentSession.indexOf(this.flashcard.id) + 1;
      } else if (this.isScenario) {
        total = this.category?.counts.total;
        position = (total - this.currentSession.length) + this.currentSession.indexOf(this.flashcard.id) + 1;
      } else {
        position = this.currentSession.indexOf(this.flashcard.id) + 1;
        total = this.currentSession.length;
      }

      return {
        position: position,
        total: total,
      };
    },
    currentSession() {
      return this.$store.getters['flashcards/currentSession'];
    },
    isQotD() {
      return this.$route.name && this.$route.name.includes('qotd');
    },
    isScenario() {
      return this.$route.name && this.$route.name.includes('scenario');
    },
    showPosition() {
      if (this.isQotD) return false;
      return this.currentPosition.total > 0 && this.currentPosition.position > 0;
    },
    showNext() {
      return this.currentPosition.position < this.currentPosition.total;
    },
    showPrevious() {
      return this.currentPosition.position > 1;
    },
  },
};
